// @flow
import CreateSpoonerismOverlay from './CreateSpoonerismOverlay';
import Logo from './Logo';
import React, { Component } from 'react';
import { Banner, Button, Heading, Section } from 'rebass';
import TweetButton from './TweetButton';

export default class SpoonerismBanner extends Component {
  props: {
    background: string,
    foreground: string,
    onChange: (phrase: string) => void,
    phrase: string,
    spoonerism: string,
  };

  state = {
    isCreating: false,
  };

  handleCreate(phrase: string) {
    this.handleToggleCreating();
    this.props.onChange(phrase);
  }

  handleToggleCreating() {
    this.setState({isCreating: !this.state.isCreating});
  }

  render() {
    const { background, foreground, phrase, spoonerism } = this.props;
    return (
      <div>
        <Banner backgroundColor={background}>
          <Section>
            <Logo
              foreground={foreground}
              mb={1}
              width={100}
            />
            <Heading
              big={true}
              color="white"
              level={1}
              style={{textAlign: 'center'}}>
              {spoonerism}
            </Heading>
          </Section>
          <Section>
            { phrase ? (
              <TweetButton
                key={spoonerism}
                phrase={phrase}
                spoonerism={spoonerism}
              />
            ) : null }
            <Button
              backgroundColor={foreground}
              onClick={this.handleToggleCreating.bind(this)}
              mt={4}>
              Create a spoonerism
            </Button>
          </Section>
        </Banner>
        { this.state.isCreating ? (
          <CreateSpoonerismOverlay
            defaultPhrase={phrase}
            onCancel={this.handleToggleCreating.bind(this)}
            onCreate={this.handleCreate.bind(this)}
          />
        ) : null }
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SpoonerismBanner.js
 **/